<crnt-form-control>
  <crnt-form-control-label slot="label">
    <label [for]="control.id">
      {{ control.options.label }}
      @if (showOptional) {
        <crnt-form-control-label-indicator>
          (optioneel)
        </crnt-form-control-label-indicator>
      }
    </label>
  </crnt-form-control-label>
  @if (control.options.helpText) {
    <crnt-form-control-help-text slot="help">
      {{ control.options.helpText }}
    </crnt-form-control-help-text>
  }

  @if (control.hasError()) {
    <rfa-errors slot="validation" [control]="control"></rfa-errors>
  }
  <crnt-text-input>
    @if (control.options.prefix) {
      <rfa-prefix-suffix
        slot="leading"
        [prefixSuffix]="control.options.prefix"
      ></rfa-prefix-suffix>
    }
    <input
      [id]="control.id"
      [formControl]="control"
      [wlAutomationId]="control.options.dataAutomationId"
      [name]="autocompleteId"
      [type]="control.options.inputType || 'text'"
      [autocomplete]="autocompleteId"
      [wlTrackFieldfocus]="focusChangeTrackConfig()"
    />
    @if (control.options.suffix) {
      <rfa-prefix-suffix
        slot="trailing"
        [prefixSuffix]="control.options.suffix"
      ></rfa-prefix-suffix>
    }
  </crnt-text-input>
</crnt-form-control>
